import React, {
    useEffect,
    useMemo,
    useState
} from "react";

import axios from "axios";

import Layout from "../layout/Layout";

import {
    ToastContainer,
    toast
} from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import "./MutualManagement.css";



const API =
"https://data.shreemwell.in/api/connection-requests";



export default function MutualManagement(){



// =====================================
// TOKEN
// =====================================

const token =
localStorage.getItem("token");




// =====================================
// CURRENT LOGIN USER ID
// =====================================

const currentUserId = useMemo(()=>{


if(!token)
return "";



try{


const payload =
JSON.parse(
window.atob(
token.split(".")[1]
)
);



return String(
payload.id ||
payload._id
);


}
catch(error){

return "";

}


},[token]);





// =====================================
// STATES
// =====================================


const [requests,setRequests] =
useState([]);



const [loading,setLoading] =
useState(true);



// Tabs
// new = Incoming Pending
// edit = Accepted/Hold/Rejected
// all = All Requests

const [activeTab,setActiveTab] =
useState("new");



// Edit dropdown row

const [editRow,setEditRow] =
useState(null);



// Confirm popup

const [showConfirm,setShowConfirm] =
useState(false);



const [selectedData,setSelectedData] =
useState({

id:"",
action:""

});





// =====================================
// INITIAL LOAD
// =====================================


useEffect(()=>{


if(token){

fetchRequests();

}


},[token]);







// =====================================
// GET ALL REQUESTS
// WITH DUPLICATE REMOVE
// =====================================


const fetchRequests = async()=>{


try{


setLoading(true);



const res = await axios.get(

`${API}/all`,

{

headers:{

Authorization:
`Bearer ${token}`

}

}

);



console.log(
"ALL REQUEST DATA",
res.data
);




// ================================
// REMOVE DUPLICATE CONNECTION
// A-B only one row
// ================================


const data =
res.data.data || [];



const uniqueRequests =
data.filter(

(item,index,self)=>{


const currentKey =

String(item.sender?._id)
+
"_"
+
String(item.receiver?._id);



const firstIndex =

self.findIndex(

(req)=>{


const reqKey =

String(req.sender?._id)
+
"_"
+
String(req.receiver?._id);



const reverseKey =

String(req.receiver?._id)
+
"_"
+
String(req.sender?._id);



return (

reqKey === currentKey

||

reverseKey === currentKey

);


}

);



return index === firstIndex;



}

);





setRequests(
uniqueRequests
);



}

catch(error){


console.log(
error
);


toast.error(
"Failed to load requests"
);


}

finally{


setLoading(false);


}



};


// =====================================
// OPEN CONFIRM MODAL
// =====================================


const openConfirm = (id,action)=>{


setSelectedData({

id,
action

});


setShowConfirm(true);


};





// =====================================
// CLOSE CONFIRM MODAL
// =====================================


const closeConfirm = ()=>{


setShowConfirm(false);



setSelectedData({

id:"",
action:""

});


};






// =====================================
// UPDATE REQUEST STATUS
// Accept / Reject / Hold
// =====================================


const updateStatus = async()=>{


try{


await axios.put(


`${API}/${selectedData.id}/status`,


{

status:selectedData.action

},


{

headers:{

Authorization:
`Bearer ${token}`

}

}


);




toast.success(

`Request ${selectedData.action}`

);



closeConfirm();



fetchRequests();



}

catch(error){


console.log(error);


toast.error(
"Status update failed"
);


}


};








// =====================================
// UNMUTUAL
// Remove Connection
// =====================================


const unMutual = async(userId)=>{


try{


await axios.put(

`${API}/unmutual/${userId}`,

{},

{

headers:{

Authorization:
`Bearer ${token}`

}

}

);




toast.success(
"Connection removed"
);




// Remove from UI

setRequests(prev=>

prev.filter(item=>


String(item.sender?._id)
!==
String(userId)

&&


String(item.receiver?._id)
!==
String(userId)


)

);



}

catch(error){


console.log(error);


toast.error(
"Unable to remove connection"
);


}



};









// =====================================
// GET OTHER USER
// IMPORTANT
// Avoid 1.1 / 1.2 Duplicate
// =====================================


const getOtherUser = (item)=>{


if(
!item.sender ||
!item.receiver
)

return null;




return (

String(item.sender._id)
===
String(currentUserId)

)

?

item.receiver

:

item.sender;



};









// =====================================
// STATUS TEXT
// =====================================


const getStatusText = (item)=>{

    if(item.status === "Accepted"){

        return "🤝 ";

    }

    if(item.mutual === true){

        return "🤝 Mutual";

    }

    return item.status;

};







// =====================================
// STATUS CSS
// =====================================


const getStatusClass = (item)=>{


if(item.mutual===true){


return "Mutual";


}



return item.status;



};









// =====================================
// NEW REQUEST TAB
// Only incoming Pending
// =====================================


const newRequests = requests.filter((item)=>{


return (


String(item.receiver?._id)
===
String(currentUserId)



&&



item.status === "Pending"



);



});








// =====================================
// EDIT REQUEST TAB
// Accepted / Hold / Rejected / Mutual
// =====================================


const editRequests = requests.filter((item)=>{


return (


(

String(item.sender?._id)
===
String(currentUserId)


||


String(item.receiver?._id)
===
String(currentUserId)


)


&&


item.status !== "Pending"



);



});









// =====================================
// ALL REQUEST TAB
// =====================================


const allRequests = requests.filter(
  (item) => item.status === "Accepted"
);
// =====================================
// ACTIVE TAB DATA
// =====================================


let filteredRequests = [];



switch(activeTab){


case "new":


filteredRequests =
newRequests;


break;



case "edit":


filteredRequests =
editRequests;


break;



case "all":


default:


filteredRequests =
allRequests;


break;



}
return (

<Layout>

<ToastContainer

position="top-right"

autoClose={2500}

theme="colored"

/>


<div className="mutual-container">
  {/* PAGE HEADER */}

<div className="page-header">

<h2>
Mutual Management
</h2>

</div>



{/* =========================
TABS
========================= */}

<div className="tab-box">


<button

className={
activeTab==="new"
?
"tab active"
:
"tab"
}

onClick={()=>setActiveTab("new")}

>

New Request

</button>




<button

className={
activeTab==="edit"
?
"tab active"
:
"tab"
}

onClick={()=>setActiveTab("edit")}

>

Edit Request

</button>




<button

className={
activeTab==="all"
?
"tab active"
:
"tab"
}

onClick={()=>setActiveTab("all")}

>

All Requests

</button>


</div>
{/* =========================
TABLE
========================= */}


<div className="table-card">


<table>


<thead>


<tr>


<th style={{width:"60px"}}>
Sr.
</th>


<th>
Name
</th>


<th>
Mobile
</th>


<th>
Email
</th>


<th>
Status
</th>


{
activeTab !== "all" &&

<th style={{width:"240px"}}>
Action
</th>
}


</tr>


</thead>





<tbody>


{

loading ?


(

<tr>

<td
colSpan={activeTab === "all" ? "5" : "6"}
className="text-center"
>

Loading...

</td>

</tr>

)



:


filteredRequests.length === 0 ?


(

<tr>

<td
colSpan="6"
className="text-center"
>

No Requests Found

</td>

</tr>

)



:


filteredRequests.map((item,index)=>{



const user =
getOtherUser(item);



if(!user)
return null;



return (


<tr key={item._id}>


{/* SR NO */}

<td>

{index+1}

</td>




{/* NAME */}

<td>

{
user.name || "-"
}

</td>




{/* MOBILE */}

<td>

{
user.phone || "-"
}

</td>





{/* EMAIL */}

<td>

{
user.email || "-"
}

</td>





{/* STATUS */}

<td>


<span

className={
`badge ${getStatusClass(item)}`
}

>

{
getStatusText(item)
}


</span>


</td>






{/* ACTION */}

<td>



{/* ====================
NEW TAB
==================== */}


{

activeTab==="new" &&


<div className="action-buttons">



<button

className="btn accept"

onClick={()=>


openConfirm(

item._id,

"Accepted"

)


}

>

Accept

</button>





<button

className="btn hold"

onClick={()=>


openConfirm(

item._id,

"Hold"

)


}

>

Hold

</button>





<button

className="btn reject"

onClick={()=>


openConfirm(

item._id,

"Rejected"

)


}

>

Reject

</button>



</div>



}





{/* ====================
EDIT TAB
==================== */}



{


activeTab==="edit" &&



<>


{


editRow === item._id ?



(


<select


className="status-select"


defaultValue=""


onChange={(e)=>{


const value =
e.target.value;



if(!value)
return;




// Unmutual

if(value==="Unmutual"){



const otherUserId =


String(item.sender._id)
===

String(currentUserId)


?


item.receiver._id


:


item.sender._id;




unMutual(otherUserId);



}




else{



openConfirm(

item._id,

value

);



}



setEditRow(null);



}}



>



<option value="">

Select Action

</option>



<option value="Accepted">

Accept

</option>



<option value="Hold">

Hold

</option>



<option value="Rejected">

Reject

</option>



<option value="Unmutual">

🤝 Unmutual

</option>



</select>



)



:




<button


className="btn edit"



onClick={()=>


setEditRow(item._id)

}



>

Edit

</button>



}



</>



}






{/* ====================
ALL TAB
==================== */}



{/* ====================
ALL TAB
==================== */}





</td>



</tr>



)


})


}



</tbody>



</table>


</div>



{/* =========================
CONFIRM MODAL
========================= */}


{

showConfirm &&


<div className="modal-bg">


<div className="confirm-box">


<h3>
Confirm Action
</h3>



<p>

Are you sure you want to

<strong>
{" "}
{selectedData.action}
{" "}
</strong>

this request?

</p>




<button

className="yes"

onClick={updateStatus}

>

Yes

</button>





<button

className="no"

onClick={closeConfirm}

>

No

</button>



</div>


</div>


}

</div>


</Layout>


);


}